import { type Common } from './common.js';
import {
  type BaseScenario,
  type FindAllOptions,
  type FindAllOptionsBasic,
  type HistoryEvent,
  type Job,
  type Scenario,
  type ScenarioBasic,
  parse,
} from './models/scenario.js';

export class API {
  common: Common;
  baseEndpoint = `/scenarios`;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions = {}): Promise<Scenario[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    const results = await this.common.getJSON(url);
    return results.map(parse);
  }

  async findAllBasic(options: FindAllOptionsBasic = {}): Promise<ScenarioBasic[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/basic`, options);
    return await this.common.getJSON(url);
  }

  async findAllJobs(): Promise<Job[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/jobs`);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Scenario> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const result = await this.common.getJSON(url);
    return parse(result);
  }

  async findHistory(id: string): Promise<HistoryEvent[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/history`);
    return await this.common.getJSON(url);
  }

  async create(values: BaseScenario): Promise<Scenario> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    const result = await this.common.postJSON(url, values);
    return parse(result);
  }

  async update(id: string, values: BaseScenario): Promise<Scenario> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const result = await this.common.patchJSON(url, values);
    return parse(result);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
